import { render, staticRenderFns } from "./loading.vue?vue&type=template&id=201967b9&scoped=true"
import script from "./loading.vue?vue&type=script&lang=js"
export * from "./loading.vue?vue&type=script&lang=js"
import style0 from "./loading.vue?vue&type=style&index=0&id=201967b9&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "201967b9",
  null
  
)

export default component.exports